import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["id", "open"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import { createElement } from '@jd/jmtd-tools/es/element';
import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import { css, px } from '@jd/jmtd-tools/es/css';
import MessageContent from '../MessageContent';
import ConfigConsumer from '../ConfigConsumer';
import * as staticMessage from './StaticMessage';
import { PortalConsumer } from '../PortalWrapper';
var count = 0;
var portal;

var Message = /*#__PURE__*/function (_PureComponent) {
  _inherits(Message, _PureComponent);

  var _super = _createSuper(Message);

  function Message() {
    var _this;

    _classCallCheck(this, Message);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "idle", true);

    _defineProperty(_assertThisInitialized(_this), "transitionEnd", function () {
      // 关闭动画结束后置于空闲态
      var _assertThisInitialize = _assertThisInitialized(_this),
          open = _assertThisInitialize.props.open;

      if (!open) {
        _this.idle = true;
      }
    });

    return _this;
  }

  _createClass(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var open = _ref.open;
      this.update(open);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "update",
    value: function update(lastOpen) {
      var _this2 = this;

      var ref = this.ref,
          _this$marginSpace = this.marginSpace,
          marginSpace = _this$marginSpace === void 0 ? 16 : _this$marginSpace,
          _this$props = this.props,
          open = _this$props.open,
          autoHideDuration = _this$props.autoHideDuration,
          onClose = _this$props.onClose;

      if (open !== lastOpen) {
        if (open) {
          ref.classList.add('jmtd-message-open');
          css(ref, {
            height: px(ref.children[0].offsetHeight + marginSpace)
          }); // 如果从空闲态，至于最底

          if (this.idle) {
            css(ref, 'order', count++);
          }

          this.idle = false;
          window.clearTimeout(this.countdown);

          if (autoHideDuration) {
            this.countdown = setTimeout(function () {
              if (!_this2.unmounted) {
                onClose();
              }
            }, autoHideDuration);
          }
        } else {
          ref.classList.remove('jmtd-message-open');
          css(ref, {
            height: 0
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          open = _this$props2.open,
          other = _objectWithoutProperties(_this$props2, _excluded);

      return /*#__PURE__*/React.createElement(PortalConsumer, null, function (portalRoot) {
        portal = portal || createElement('div.jmtd-message-portal', portalRoot !== null && portalRoot !== void 0 ? portalRoot : document.body);
        return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
          var _ref2$messageSpace = _ref2.messageSpace,
              messageSpace = _ref2$messageSpace === void 0 ? 16 : _ref2$messageSpace;
          _this3.messageSpace = messageSpace;
          return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
            id: id,
            className: "jmtd-message-wrapper",
            ref: function ref(el) {
              _this3.ref = el;
            },
            onTransitionEnd: _this3.transitionEnd
          }, /*#__PURE__*/React.createElement(MessageContent, other)), portal);
        });
      });
    }
  }]);

  return Message;
}(PureComponent);

export { Message as default };
Message.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.any,
  type: PropTypes.oneOf(['info', 'success', 'help', 'warning', 'danger', 'loading']),
  open: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  onClose: PropTypes.func
};
Message.defaultProps = {
  id: null,
  children: null,
  className: '',
  type: null,
  open: false,
  autoHideDuration: 3000,
  onClose: function onClose() {}
}; // 向 Message 组件添加静态方法

staticMessage.init(Message);
Message.open = staticMessage.open;
Message.info = staticMessage.info;
Message.success = staticMessage.success;
Message.help = staticMessage.help;
Message.warning = staticMessage.warning;
Message.danger = staticMessage.danger;
Message.loading = staticMessage.loading;
Message.close = staticMessage.close;